<template>
  <div id="newvolunteer">
    <div class="action">
      <div class="back" @click="goBack()">
        <img src="/img/left-arrow-white.svg" />
        <span class="text">{{ $t("login.back") }}</span>
      </div>
    </div>
    <div id="form">
      <v-container fluid grid-list-md>
        <v-layout row wrap class="box">
          <!-- <div class="box" v-if="!form_completed"> -->
          <div class="header">
            <div class="logo">
              <p>{{ $t("volunteer_form_literals.colaboration_with") }}</p>
              <img src="/img/logo_new_black.png"/>
            </div>
            <h2>{{ $t("login.volunteers") }}</h2>
          </div>

          <h3>{{ $t("params.user_information") }}</h3>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.name") }} <span class="obligatory">*</span>
              </label>
              <input
                class="upper shadow"
                :class="{ error: error.volunteer.name }"
                type="text"
                v-model="volunteer.name"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.surname") }} <span class="obligatory">*</span>
              </label>
              <input
                class="upper shadow"
                :class="{ error: error.volunteer.surname }"
                type="text"
                v-model="volunteer.surname"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.parent_document") }} <span class="obligatory">*</span>
              </label>
              <v-radio-group v-model="volunteer.id_type" row>
                <v-radio value="1">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.id_type }">{{
                      $t("params.dni")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="2">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.id_type }">{{
                      $t("params.nie")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="3">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.id_type }">{{
                      $t("params.passport")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
              <input
                class="upper shadow"
                :class="{ error: error.volunteer.id_number }"
                type="text"
                v-model="volunteer.id_number"
                :disabled="volunteer.id_type == ''"
              />
            </div>
          </v-flex>

          <!-- <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.avatar") }}</label>
              <input
                v-show="volunteer.files.avatar == ''"
                type="file"
                ref="avatar"
                @change="previewFiles($event, 'avatar')"
              />
              <img
                v-show="volunteer.files.avatar != ''"
                :src="volunteer.files.avatar"
                @error="defaultPreview()"
                @click="
                  $refs.avatar.value = '';
                  volunteer.files.avatar = '';
                "
              />
              <p class="filename" v-show="volunteer.files.avatar != ''">
                {{ filenames.avatar }}
              </p>
            </div>
          </v-flex> -->

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.gender") }} <span class="obligatory">*</span></label>
              <v-radio-group v-model="volunteer.gender" row>
                <v-radio value="1">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.gender }">{{
                      $t("gender.male")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="2">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.gender }">{{
                      $t("gender.female")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="NULL">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.gender }">{{
                      $t("gender.no_answer")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.birthday") }} <span class="obligatory">*</span> <span> {{$t('format')}}: (dd/mm/yyyy)</span>
              </label>
              <v-menu
                v-model="dialog_birthday"
                autocomplete="new-text"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                :class="error.volunteer.birthday ? 'error' : ''"
              >
              <template v-slot:activator="{ on }">
              <v-text-field
                  prepend-icon="event"
                  v-model="volunteer.parsedBirthday"
                  @click:prepend="dialog_birthday = true"
                  :placeholder="'DD/MM/YYYY'"
                  :class="error.volunteer.birthday ? 'error' : ''"
              ></v-text-field>

              </template>
              <v-date-picker v-model="volunteer.birthday" @input="dialog_birthday = false, formatBirthday()" ></v-date-picker>
              </v-menu>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.email") }} <span class="obligatory">*</span>
              </label>
              <input
                class="shadow"
                :class="{ error: error.volunteer.email }"
                type="text"
                v-model="volunteer.email"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.phone") }}<span class="obligatory">*</span>
              </label>
              <vue-tel-input
                v-model="volunteer.phone1"
                inputId="phone1-input"
                defaultCountry="ES"
                :class="{ error: error.volunteer.phone1 }"
                @input="inputPhone1"
                :inputOptions= '{ showDialCode: true }'
              ></vue-tel-input>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.phone2") }}
              </label>
              <vue-tel-input
                v-model="volunteer.phone2"
                inputId="phone2-input"
                defaultCountry="ES"
                :class="{ error: error.volunteer.phone2 }"
                @input="inputPhone2"
                :inputOptions= '{ showDialCode: true }'
              ></vue-tel-input>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.country") }} {{ $t("params.current_residence") }}<span class="obligatory">*</span></label>
              <v-autocomplete
                :class="error.volunteer.country ? 'error' : ''"
                v-model="volunteer.country"
                :items="Object.values(countries)"
                item-text="name"
                item-value="id"
                no-data
                :browser-autocomplete="'asd2saS<'"
                hide-no-data
                attach
              >
              </v-autocomplete>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.city") }} {{ $t("params.current_residence") }} <span class="obligatory">*</span></label>
              <input
                type="text"
                class="shadow"
                :class="{ error: error.volunteer.city }"
                v-model="volunteer.city"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.cp") }} {{ $t("params.current_residence") }} <span class="obligatory">*</span></label>
              <input
                type="number"
                class="shadow"
                :class="{ error: error.volunteer.cp }"
                v-model="volunteer.cp"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.instagram") }}
              </label>
              <input
                class="shadow"
                :class="{ error: error.volunteer.instagram }"
                type="text"
                v-model="volunteer.instagram"
                @input="getInstagramUsername()"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.drive") }} <span class="obligatory">*</span></label>
              <v-radio-group v-model="volunteer.b_carnet" row>
                <v-radio value="1">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.b_carnet }">{{
                      $t("bool.si")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="0">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.b_carnet }">{{
                      $t("bool.no")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-flex>

          <!-- <v-flex xs12 md6 lg6 xl6 v-show="volunteer.b_carnet == 1">
            <div class="item">
              <label>{{ $t("params.owncar") }}</label>
              <v-radio-group v-model="volunteer.b_coche" row>
                <v-radio value="1">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.b_coche }">{{
                      $t("bool.si")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="0">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.b_coche }">{{
                      $t("bool.no")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6 v-show="volunteer.b_carnet == 1">
            <div class="item">
              <label>{{ $t("params.drivetype") }}</label>
              <v-autocomplete
                :class="error.volunteer.driveType ? 'error' : ''"
                v-model="volunteer.driveType"
                :items="driveTypeOptions"
                no-data
                flat
                attach
                multiple
                hide-details
                hide-selected
                :browser-autocomplete="'asd2saS<'"
                hide-no-data
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="
                      volunteer.driveType.splice(
                        volunteer.driveType.indexOf(data.item),
                        1
                      )
                    "
                  >
                    {{ data.item }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content
                      v-text="data.item"
                    ></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6 v-show="volunteer.b_carnet == 1">
            <div class="item">
              <label>{{ $t("params.drivelicense_front") }}</label>
              <input
                v-show="volunteer.files.drivelicense_front == ''"
                type="file"
                ref="drivelicense_front"
                @change="previewFiles($event, 'drivelicense_front')"
              />
              <img
                v-show="volunteer.files.drivelicense_front != ''"
                :src="volunteer.files.drivelicense_front"
                @error="defaultPreview()"
                @click="
                  $refs.drivelicense_front.value = '';
                  volunteer.files.drivelicense_front = '';
                "
              />
              <p
                class="filename"
                v-show="volunteer.files.drivelicense_front != ''"
              >
                {{ filenames.drivelicense_front }}
              </p>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6 v-show="volunteer.b_carnet == 1">
            <div class="item">
              <label>{{ $t("params.drivelicense_back") }}</label>
              <input
                v-show="volunteer.files.drivelicense_back == ''"
                type="file"
                ref="drivelicense_back"
                @change="previewFiles($event, 'drivelicense_back')"
              />
              <img
                v-show="volunteer.files.drivelicense_back != ''"
                :src="volunteer.files.drivelicense_back"
                @error="defaultPreview()"
                @click="
                  $refs.drivelicense_back.value = '';
                  volunteer.files.drivelicense_back = '';
                "
              />
              <p
                class="filename"
                v-show="volunteer.files.drivelicense_back != ''"
              >
                {{ filenames.drivelicense_back }}
              </p>
            </div>
          </v-flex> -->

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.how_meet_present") }} <span class="obligatory">*</span>
              </label>
              <v-select
                ref="selectVolunteerHowMeet"
                :class="error.volunteer.how_meet ? 'error' : ''"
                v-model="volunteer.how_meet"
                :items="Object.values(how_meet)"
                :item-text="item => $t(item.name)"
                item-value="id"
                flat
                :browser-autocomplete="'asd2saS<'"
                hide-details
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                  >
                    {{ $t(data.item.name) }}
                  </v-chip>
                </template>
              </v-select>
            </div>
          </v-flex>

            <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.cv") }} <span class="obligatory">*</span></label>
              <input
                v-show="volunteer.files.cv == ''"
                :class="error.volunteer.cv ? 'error' : ''"
                type="file"
                ref="cv"
                @change="previewFiles($event, 'cv')"
              />
              <img
                v-show="volunteer.files.cv != ''"
                :src="volunteer.files.cv"
                @error="defaultPreview"
                @click="
                  $refs.cv.value = '';
                  volunteer.files.cv = '';
                "
              />
              <p class="filename" v-show="volunteer.files.cv != ''">
                {{ filenames.cv }}
              </p>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.ss") }} <span class="obligatory">*</span></label>
              <input
                v-show="volunteer.files.ss == ''"
                :class="error.volunteer.ss ? 'error' : ''"
                type="file"
                ref="ss"
                @change="previewFiles($event, 'ss')"
              />
              <img
                v-show="volunteer.files.ss != ''"
                :src="volunteer.files.ss"
                @error="defaultPreview"
                @click="
                  $refs.ss.value = '';
                  volunteer.files.ss = '';
                "
              />
              <p class="filename" v-show="volunteer.files.ss != ''">
                {{ filenames.ss }}
              </p>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.dni") }} <span class="obligatory">*</span></label>
              <input
                v-show="volunteer.files.dni == ''"
                :class="error.volunteer.dni ? 'error' : ''"
                type="file"
                ref="dni"
                @change="previewFiles($event, 'dni')"
              />
              <img
                v-show="volunteer.files.dni != ''"
                :src="volunteer.files.dni"
                @error="defaultPreview"
                @click="
                  $refs.dni.value = '';
                  volunteer.files.dni = '';
                "
              />
              <p class="filename" v-show="volunteer.files.dni != ''">
                {{ filenames.dni }}
              </p>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.num_ss") }}
              </label>
              <input
                class="upper shadow"
                :class="{ error: error.volunteer.num_ss }"
                type="text"
                v-model="volunteer.num_ss"
              />
            </div>
          </v-flex>

        </v-layout>

        <v-layout row wrap class="box">
          <h3>{{ $t("params.mic_information") }}</h3>
          <v-flex xs12 md12 lg12 xl12>
            <div class="info">
              <p>{{ $t("params.info_colaboration") }}</p>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.studies") }} <span class="obligatory">*</span></label>
              <v-select
                ref="selectVolunteerStudies"
                :class="error.volunteer.studies ? 'error' : ''"
                v-model="volunteer.studies"
                :items="Object.values(studies)"
                :item-text="item => $t('studies.' + item.name)"
                item-value="id"
                multiple
                clearable
                @change="checkOthers('studies')"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ $t('studies.' + item.name) }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ volunteer.studies.length - 1 }})</span
                  >
                </template>
              </v-select>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6 v-if="otherStudies">
            <div class="item">
              <label
                >{{ $t("params.other_studies") }} <span class="obligatory">*</span>
              </label>
              <input
                class="upper shadow"
                :class="{ error: error.volunteer.other_studies }"
                type="text"
                v-model="volunteer.other_studies"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6 v-if="otherCafe">
            <div class="item">
              <label
                >{{ $t("params.other_cafe") }}
              </label>
              <input
                class="upper shadow"
                type="text"
                v-model="volunteer.other_cafe"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.ropec") }}<span> {{$t('format')}}: (dd/mm/yyyy)</span>
              </label>
              <v-menu
                v-model="dialog_ropec"
                autocomplete="new-text"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                :class="error.volunteer.ropec ? 'error' : ''"
              >
              <template v-slot:activator="{ on }">
              <v-text-field
                  prepend-icon="event"
                  v-model="volunteer.parsedRopec"
                  @click:prepend="dialog_ropec = true"
                  :placeholder="'DD/MM/YYYY'"
                  :class="error.volunteer.ropec ? 'error' : ''"
              ></v-text-field>

              </template>
              <v-date-picker v-model="volunteer.ropec" @input="dialog_ropec = false, formatRopec()" ></v-date-picker>
              </v-menu>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.sport_degrees") }} </label>
              <v-select
                ref="selectVolunteerStaffLevel"
                v-model="volunteer.staff_level"
                :items="Object.values(staff_level)"
                :item-text="item => $t('staff_level.' + item.name)"
                item-value="id"
                multiple
                clearable
                @change="checkOthers('staff_level')"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ $t('staff_level.' + item.name) }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ volunteer.staff_level.length - 1 }})</span
                  >
                </template>
              </v-select>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6 v-if="otherStaffLevel">
            <div class="item">
              <label
                >{{ $t("params.other_sport_degrees") }} <span class="obligatory">*</span>
              </label>
              <input
                class="shadow"
                :class="{ error: error.volunteer.other_staff_level }"
                type="text"
                v-model="volunteer.other_staff_level"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6 v-if="otherBasquet">
            <div class="item">
              <label>{{ $t("params.official_basket") }} <span class="obligatory">*</span></label>
              <v-radio-group v-model="volunteer.official_basket" row>
                <v-radio value="1">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.official_basket }">{{
                      $t("bool.si")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="2">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.official_basket }">{{
                      $t("bool.no")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="3">
                  <template v-slot:label>
                    <span :class="{ obligatory: error.volunteer.official_basket }">{{
                      $t("bool.no_but_experience")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-flex>
          <!-- <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.sex_crimes") }}</label>
              <input
                v-show="volunteer.files.sex_crimes == ''"
                type="file"
                ref="sex_crimes"
                @change="previewFiles($event, 'sex_crimes')"
              />
              <img
                v-show="volunteer.files.sex_crimes != ''"
                :src="volunteer.files.sex_crimes"
                @error="defaultPreview()"
                @click="
                  $refs.sex_crimes.value = '';
                  volunteer.files.sex_crimes = '';
                "
              />
              <p class="filename" v-show="volunteer.files.sex_crimes != ''">
                {{ filenames.sex_crimes }}
              </p>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.sex_crimes_date") }} <span class="obligatory">*</span>
              </label>
              <input
                class="shadow"
                :class="{ error: error.volunteer.sex_crimes_date }"
                type="date"
                v-model="volunteer.sex_crimes_date"
              />
            </div>
          </v-flex> -->

          <v-flex xs12 md12 lg12 xl12>
            <v-layout row wrap class="box">
            <v-flex xs12 md6 lg6 xl6>
              <div class="item">
                <label>{{ $t("params.language") }} <span class="obligatory">*</span></label>
                <div class="description">{{ $t("volunteer_form_literals.language_1") }}</div>
                <br />
                <div class="description">{{ $t("volunteer_form_literals.language_2") }}</div>
                <br />
                <div class="description">{{ $t("volunteer_form_literals.language_level_basic") }} <br />
                  {{ $t("volunteer_form_literals.language_level_medium") }}<br />
                  {{ $t("volunteer_form_literals.language_level_high") }}
                </div>
                <br />
                <div class="description">{{ $t("volunteer_form_literals.language_note") }}</div>
              </div>
            </v-flex>
            <v-flex xs12 md6 lg6 xl6>
                  <div class="item">
                    <label></label>
                    <label></label>
                    <label></label>
              <v-layout row wrap class="box mobile-box" style="margin-bottom: -10px;" v-for="(item, index) in volunteer.lang_level" :key="index">
                <v-flex xs12 md5 lg5 xl5 style="margin-bottom: 0px;">
                  <v-select
                  ref="langLevelLangSelect"
                  :placeholder="$t('params.language')"
                  :class="error.volunteer.lang_level ? 'error' : ''"
                  v-model="item.lang"
                  :items="Object.values(language_volunteer)"
                  :item-text="item => $t('language_volunteer.' + item.name)"
                  item-value="id"
                  no-data
                  hide-no-data
                  >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                    >
                      {{ $t('language_volunteer.' + data.item.name) }}
                    </v-chip>
                  </template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md5 lg5 xl5 style="margin-bottom: 0px;">
                <v-select
                  ref="langLevelLevelSelect"
                  :placeholder="$t('params.level')"
                  :class="error.volunteer.lang_level ? 'error' : ''"
                  v-model="item.level"
                  :items="Object.values(levels)"
                  :item-text="item => $t('volunteer_form_literals.language_' + item.name)"
                  item-value="id"
                  no-data
                  hide-no-data
                  >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                    >
                      {{ $t('volunteer_form_literals.language_' + data.item.name) }}
                    </v-chip>
                  </template>
                  </v-select>
                </v-flex>
                <v-flex xs2 md2 lg2 xl2 class="icon" style="padding-top: 10px;">
                  <v-icon v-if="volunteer.lang_level.length > 1" @click="volunteer.lang_level.splice(index, 1)">remove</v-icon>
                  <v-icon v-if="index == volunteer.lang_level.length-1 && volunteer.lang_level.length < 7" @click="volunteer.lang_level.push({lang:'', level:''});">add</v-icon>
                </v-flex>
              </v-layout>
                </div>
            </v-flex>
          </v-layout>
          </v-flex>

          <!-- <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.reason") }}</label>
              <textarea
                class="shadow"
                :class="{ error: error.volunteer.reason }"
                v-model="volunteer.reason"
              ></textarea>
            </div>
          </v-flex> -->

          <!--
            close
                      @input="removeOption(data.item)"
           -->

           <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label>{{ $t("params.been_before") }}</label>
              <v-radio-group v-model="beenBefore" row>
                <v-radio value="1">
                  <template v-slot:label>
                    <span>{{
                      $t("bool.si")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="0">
                  <template v-slot:label>
                    <span>{{
                      $t("bool.no")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-flex>

          <v-flex xs12 md12 lg12 xl12 v-if="beenBefore == '1'">
              <div class="item" style="width: 95%;">
                <label> {{$t('params.events_done')}}</label>
                <v-layout row wrap v-for="(item, index) in volunteer.events_done" :key="index" class="mobile-box">
                  <v-flex xs12 md4 lg4 xl4>
                    <v-select
                    ref="eventsDoneEventSelect"
                    v-model="item.events"
                    :items="Object.values(events_type)"
                    item-text="name"
                    item-value="id"
                    >
                    <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                    >
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                    </v-select>
                  </v-flex>
                  <v-flex xs12 md2 lg2 xl2>
                    <v-select
                    ref="eventsDoneYearSelect"
                    v-model="item.year"
                    :items="years"
                    item-text="name"
                    item-value="id"
                    multiple
                    clearable
                    >
                    <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                    </v-select>
                  </v-flex>
                  <v-flex xs12 md5 lg5 xl5>
                    <v-select
                    ref="eventsDoneRoleSelect"
                    v-model="item.role"
                    :items="Object.values(role_volunteer)"
                    :item-text="item => $t('role_volunteer_event.' + item.name)"
                    item-value="id"
                    :item-disabled="item => item.parent_id == null"
                    >
                    <template slot='item' slot-scope='{ item }'>
                      <span class="parent" v-if="item.parent_id == null" style="margin-left: 0px; color: #999">
                        {{ $t('role_volunteer_event.' + item.name) }}
                      </span>
                      <span v-else style="margin-left: 35px;">
                        {{ $t('role_volunteer_event.' + item.name) }}
                      </span>
                    </template>

                    <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                    >
                      {{ $t('role_volunteer_event.' + data.item.name) }}
                    </v-chip>
                  </template>
                    </v-select>
                  </v-flex>

                  <v-flex xs1 md1 lg1 xl1 class="icon" style="padding-top: 10px;">
                  <v-icon v-if="volunteer.events_done.length > 1" @click="volunteer.events_done.splice(index, 1)">remove</v-icon>
                  <v-icon v-if="index == volunteer.events_done.length-1 && volunteer.events_done.length < 7" @click="volunteer.events_done.push({events: '', role: '', year: ''});">add</v-icon>
                </v-flex>
                </v-layout>
              </div>
          </v-flex>

        </v-layout>

        <v-layout row wrap class="box">
          <h3>{{ $t("params.working_areas") }}</h3>
          <v-flex xs12 md12 lg12 xl12>
            <div class="info">
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
                <label>{{ $t("params.working_areas_description") }}<span class="obligatory">*</span></label>
              <v-select
                ref="selectVolunteerWorkingAreas"
                :class="error.volunteer.working_areas ? 'error' : ''"
                v-model="volunteer.working_areas"
                :items="Object.values(working_areas)"
                :item-text="item => $t('working_areas.' + item.name)"
                item-value="id"
                multiple
                clearable
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ $t('working_areas.' + item.name) }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ volunteer.working_areas.length - 1 }})</span
                  >
                </template>
              </v-select>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
                <label>{{ $t("params.working_event") }}<span class="obligatory">*</span></label>
              <v-select
                ref="selectVolunteerWorkingEvent"
                :class="error.volunteer.working_event ? 'error' : ''"
                v-model="volunteer.working_event"
                :items="Object.values(working_event)"
                :item-text="item => item.name"
                item-value="id"
                multiple
                clearable
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ volunteer.working_event.length - 1 }})</span
                  >
                </template>
              </v-select>
            </div>
          </v-flex>

        </v-layout>

        <v-layout row wrap class="box">
          <h3>{{ $t("params.access_information") }}</h3>
          <v-flex xs12 md12 lg12 xl12>
            <div class="info">
              <p>{{ $t("params.info_access_colaborator") }}</p>
            </div>
          </v-flex>

          <v-flex xs12 md12 lg12 xl12 v-if="volunteer.id_number!=''">
            <div class="item" style="width: 95%;">
              <label>{{ $t("params.username") + " (" + $t("params.parent_document") + ")" }}</label>
              <div style="padding-left: 20px;" class="description">{{volunteer.id_number.toUpperCase()}}</div>
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.password") }} <span class="obligatory">*</span>
              </label>
              <input
                type="password"
                class="shadow"
                :class="{ error: error.volunteer.password }"
                v-model="volunteer.password"
              />
            </div>
          </v-flex>

          <v-flex xs12 md6 lg6 xl6>
            <div class="item">
              <label
                >{{ $t("params.password_confirmation") }}
                <span class="obligatory">*</span></label
              >
              <input
                type="password"
                class="shadow"
                :class="{ error: error.volunteer.password2 }"
                v-model="password2"
              />
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="box">
          <h3>{{ $t("descriptions.terms_and_conditions_2") }}</h3>
          <v-flex xs12 md12 lg12 xl12>
            <div class="middle-box">
              <!-- <div class="legal">
                <v-checkbox
                  v-model="terms_and_conditions"
                  class="terms_and_conditions"
                >
                  <template v-slot:label>
                    <span :class="{ obligatory: error.terms_and_conditions }">
                      {{ $t("descriptions.terms_and_conditions_1") }}
                      <a target="_blank" :href="''">{{
                        $t("descriptions.terms_and_conditions_2")
                      }}</a>
                    </span>
                  </template>
                </v-checkbox>
              </div> -->

              <div class="legal">
                <v-checkbox
                  v-model="privacy_policy"
                  class="terms_and_conditions"
                >
                  <template v-slot:label>
                    <span :class="{ obligatory: error.privacy_policy }">
                      {{ $t("descriptions.privacy_policy_1") }}
                      <a target="_blank" :href="privacy_url">{{
                        $t("descriptions.privacy_policy_2")
                      }}</a>
                    </span>
                  </template>
                </v-checkbox>
                      <a target="_blank" :href="privacyMore_url">
                <button class="information" v-on:click="openDialog()" > {{$t('more_information')}}</button></a>
              </div>

              <div class="legal">
                <v-checkbox
                  v-model="b_work"
                  class="terms_and_conditions"
                >
                  <template v-slot:label>
                    <span :class="{ obligatory: error.b_work }">
                      {{ $t("descriptions.borsa_treball") }}
                    </span>
                  </template>
                </v-checkbox>
              </div>

              <!-- <div class="middle-box">
                <span v-if="error.volunteer.recaptcha" class="obligatory">* {{$t('errors.recaptcha')}}</span>
                <div class="g-recaptcha" :data-sitekey="captcha_key"></div>
              </div> -->
              <span v-if="error.recaptcha" class="obligatory">* {{$t('errors.recaptcha')}}</span>
              <vue-recaptcha class="g-recaptcha" :sitekey="captcha_key" @verify="captchaVerify = true" @expired="captchaVerify = false" :loadRecaptchaScript="true"></vue-recaptcha>

            </div>

            <div class="middle-box">
              <button
                type="button"
                class="save"
                id="send"
                v-on:click="validate()"
              >
                {{ $t("params.send") }}
              </button>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import i18n from '@/i18n'
import vuetifySelectOutsideClick from '@/mixins/vuetifySelectOutsideClick'

export default {
  name: 'NewVolunteer',
  mixins: [vuetifySelectOutsideClick],
  components: {
    VueRecaptcha
  },
  data () {
    return {
      volunteer: {
        name: '',
        surname: '',
        id_type: '',
        id_number: '',
        birthday: '',
        parsedBirthday: '',
        gender: '',
        email: '',
        phone1: '',
        phone1_aux: '',
        phone2: '',
        phone2_aux: '',
        country: '',
        cp: '',
        city: '',
        b_carnet: '',
        instagram: '',
        how_meet: '',
        event: [{ id: '', role: '' }],
        rrss: [{ url: '' }],
        referee_experience: '',
        referee3po: '',
        studies: [],
        other_studies: '',
        working_areas: [],
        working_event: [],
        other_cafe: '',
        ropec: '',
        staff_level: [],
        other_staff_level: '',
        official_basket: '',
        lang_level: [
          { lang: '', level: '' }
        ],
        events_done: [
          { events: [''], role: '', year: '' }
        ],
        password: '',
        files: {
          cv: '',
          ss: '',
          dni: ''
        },
        num_ss: ''
      },

      // volunteer: {
      //   name: "Adrian",
      //   surname: "Garcia Test",
      //   id_type: "1",
      //   id_number: "39400441S",
      //   birthday: "1998-07-21",
      //   gender: "1",
      //   email: "adri.ga@hotmail.com",
      //   phone1: "680321209",
      //   phone1_aux: "",
      //   phone2: "937579776",
      //   phone2_aux: "",
      //   country: "aGh5MFRaeHB5RE9EQnAxY2p0bXA4QT09",
      //   cp: "08304",
      //   city: "Mataró",
      //   b_carnet: "1",
      //   instagram: "adri.garper",
      //   how_meet: "dmh6Tnk1MXZwbkN6T1dIZTF4Q2U5QT09",
      //   event: [{id: 'Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09', role: ''}],
      //   rrss: [{url:""}],
      //   referee_experience: "",
      //   referee3po: "",
      //   studies: ['M2lyRWFHeE45SGVuZmFvWGVKNy9vQT09', 'NHpTUTVyU3JWclcvRS9qWjdVeTVlQT09'],
      //   other_studies: "DAW",
      //   other_cafe: "999999",
      //   ropec: "1998-07-21",
      //   staff_level: ['OS9VYUZmZFZSbm1YQzFWeHBSc3NzZz09', 'aXFZalgzRzFTeTVHZDVyWWIrei9uZz09'],
      //   other_staff_level: "Entrenador de Volley",
      //   official_basket: "1",
      //   lang_level: [
      //   {lang: "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09", level: "Alt"}
      //   ],
      //   events_done: [
      //   {events: ['L2F4ckN4SHh3UWc2U1d3TkVaU0dBUT09'], role: "", year: "2012"}
      //   ],
      //   password: "1111",
      //   files: {
      //     cv: "",
      //   }
      // },

      filenames: {
        cv: ''
      },

      terms_and_conditions: '',
      privacy_policy: '',
      b_work: '',
      password2: '',
      error: {
        volunteer: {
          name: false,
          surname: false,
          id_type: false,
          id_number: false,
          birthday: false,
          gender: false,
          phone1: false,
          phone2: false,
          address: false,
          cp: false,
          city: false,
          country: false,
          email: false,
          password: false,
          b_carnet: false,
          b_coche: false,
          driveType: false,
          event: false,
          event_role: false,
          reason: false,
          cv: false,
          studies: false,
          other_studies: false,
          other_cafe: false,
          staff_level: false,
          other_staff_level: false,
          official_basket: false,
          recaptcha: false,
          ss: false,
          num_ss: false,
          dni: false,
          working_areas: false
        },
        terms_and_conditions: false,
        privacy_policy: false,
        b_work: false
      },
      terms_and_conditions_link: '',
      privacy_policy_link: '',
      countries: {},
      events: {},
      events_type: {},
      how_meet: {},
      studies: {},
      working_areas: {},
      working_event: {
        'micfootball': { name: 'MICFootball', id: 'micfootball' },
        'micfootball7': { name: 'MICFootball7', id: 'micfootball7' },
        'miccamp': { name: 'MICCamp', id: 'miccamp' },
        'miccampbcn': { name: 'MICCamp Barcelona', id: 'miccampbcn' },
        'micfootballpuntacana': { name: 'MICFootball Punta Cana', id: 'micfootballpuntacana' },
        'micfootfem': { name: 'MICFootFem', id: 'micfootfem' },
        'aitanabonmati': { name: 'Campus Aitana', id: 'aitanabonmati' }
      },
      staff_level: {},
      language_volunteer: {},
      role_volunteer: {},
      volunteer_3po_options: {},
      driveTypeOptions: [
        'B1',
        'A1',
        'A2',
        'A',
        'B',
        'AM',
        'BTP',
        'C1',
        'C',
        'D',
        'D1',
        'E'
      ],
      levels: [
        { value: 1, name: 'basic' },
        { value: 2, name: 'medium' },
        { value: 3, name: 'high' }
      ],
      otherStudies: false,
      otherCafe: false,
      otherStaffLevel: false,
      otherBasquet: false,
      otherReferee: false,
      otherFotoVideo: false,
      recaptcha: false,
      captcha_key: process.env.VUE_APP_CAPTCHA_KEY,
      privacy_url: process.env.VUE_APP_APP_URL + 'files/politica-privacitat.pdf',
      privacyMore_url: process.env.VUE_APP_APP_URL + 'files/MesInfoLEGALS_CA.pdf',
      dialog_birthday: false,
      dialog_ropec: false,
      allEvents: false,
      beenBefore: '',
      captchaVerify: false
    }
  },
  created () {
    this.lang = this.$route.params.lang

    if (!['ca', 'es'].includes(this.lang)) {
      this.lang = 'ca'
    }

    i18n.loadLanguageAsync(this.lang)

    switch (this.lang) {
      case 'ca':
        this.privacy_url = process.env.VUE_APP_APP_URL + 'files/politica-privacitat.pdf'
        this.privacyMore_url = process.env.VUE_APP_APP_URL + 'files/MesInfoLEGALS_CA.pdf'
        break
      case 'es':
        this.privacy_url = process.env.VUE_APP_APP_URL + 'files/politica-privacidad.pdf'
        this.privacyMore_url = process.env.VUE_APP_APP_URL + 'files/MesInfoLEGALS_ES.pdf'
        break
        // case "en":
        //   // TODO FILES URLS
        // break;
    }

    var self = this
    // this.$store.commit( 'user/setAuthenticate', false );
    this.$store.dispatch('getInscriptionsInfo').then(function () {
      self.countries = self.$store.getters['getCountries']
      self.events = self.$store.getters['getEvents']
      self.events_type = self.$store.getters['getEventsType']
      self.how_meet = self.$store.getters['getHowMeet']
      self.studies = self.$store.getters['getStudies']
      self.working_areas = self.$store.getters['getWorkingAreas']
      self.staff_level = self.$store.getters['getStaffLevel']()
      self.language_volunteer = self.$store.getters['getLanguageVolunteer']
      self.role_volunteer = self.$store.getters['getRoleVolunteer']
      self.volunteer_3po_options = self.$store.getters['get3poOptions']
    })
  },
  methods: {
    getVuetifyOutsideClickSelectRefs () {
      return [
        'selectVolunteerHowMeet',
        'selectVolunteerStudies',
        'selectVolunteerStaffLevel',
        'selectVolunteerWorkingAreas',
        'selectVolunteerWorkingEvent',
        'langLevelLangSelect',
        'langLevelLevelSelect',
        'eventsDoneEventSelect',
        'eventsDoneYearSelect',
        'eventsDoneRoleSelect'
      ]
    },

    // GO BACK TO LOGIN
    goBack () {
      this.lang = this.$route.params.lang

      if (!['ca', 'es'].includes(this.lang)) {
        this.lang = 'ca'
      }

      i18n.loadLanguageAsync(this.lang)

      this.$router.push('/login/' + this.lang)
    },

    // CHECK IF NUMBER IS CORRECT
    inputPhone1 (name, number) {
      this.volunteer.phone1_aux = number
    },

    inputPhone2 (name, number) {
      this.volunteer.phone2_aux = number
    },

    getInstagramUsername () {
      if (
        this.volunteer.instagram.charAt(0) !== '@' &&
        this.volunteer.instagram.length > 0
      ) {
        if (this.volunteer.instagram.includes('www.instagram')) {
          var pathArray = this.volunteer.instagram.split('/')
          this.volunteer.instagram = pathArray[3]
        }
        this.volunteer.instagram = '@' + this.volunteer.instagram
      }
    },

    checkOthers (name) {
      // Check in studies select
      if (name === 'studies') {
        // Check if user selects "Altres"
        var other = Object.values(this.volunteer[name]).find(obj => {
          return this.studies[obj].name === 'others'
        })

        if (other !== undefined && other.length > 0) {
          this.otherStudies = true
        } else {
          this.otherStudies = false
        }

        // Check if user selects "CAFE"
        var cafe = Object.values(this.volunteer[name]).find(obj => {
          return this.studies[obj].name.includes('CAFE')
        })

        if (cafe !== undefined && cafe.length > 0) {
          this.otherCafe = true
        } else {
          this.otherCafe = false
        }
      }

      // Check in staff_level select
      if (name === 'staff_level') {
        // Check if user selects "Altres"
        var staffOther = Object.values(this.volunteer[name]).find(obj => {
          return this.staff_level[obj].name === 'others'
        })

        if (staffOther !== undefined && staffOther.length > 0) {
          this.otherStaffLevel = true
        } else {
          this.otherStaffLevel = false
        }

        // Check if user selects "Altres"
        var staffBasquet = Object.values(this.volunteer[name]).find(obj => {
          return this.staff_level[obj].name.includes('basket')
        })

        if (staffBasquet !== undefined && staffBasquet.length > 0) {
          this.otherBasquet = true
        } else {
          this.otherBasquet = false
        }
      }

      // Check in event select
      if (name === 'event') {
        // Check if user selects "Àrbitre"
        this.otherReferee = false
        for (let item in this.volunteer[name]) {
          if (this.otherReferee) {
            break
          }
          for (let role in this.volunteer[name][item].role) {
            if (this.role_volunteer[this.volunteer[name][item].role[role]].name.includes('referee')) {
              this.otherReferee = true
              break
            } else {
              this.otherReferee = false
            }
          }
        }

        // Check if user selects "Foto | Vídeo"
        this.otherFotoVideo = false
        for (let item in this.volunteer[name]) {
          if (this.otherFotoVideo) {
            break
          }
          for (let role in this.volunteer[name][item].role) {
            if (this.role_volunteer[this.volunteer[name][item].role[role]].name.includes('marketing_communication')) {
              this.otherFotoVideo = true
              break
            } else {
              this.otherFotoVideo = false
            }
          }
        }
      }
    },

    // PREPARATION THUMB
    previewFiles (e, name) {
      e.srcElement.nextSibling.src = '/img/file.svg'
      this.filenames[name] = this.$refs[name].files[0].name
      this.$overlay.loading()
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.$overlay.hide()
        return
      }

      // check is file is bigger than 1MB
      if (files[0].size > 1024 * 1024) {
        this.$popup.alert({
          message: i18n.t('errors.file_size'),
          btnSuccess: i18n.t('accept')
        })
        this.$overlay.hide()
        return
      }

      this.createImage(files[0], name)
    },

    // CREATION THUMB
    createImage (file, name) {
      var reader = new FileReader()
      var self = this

      reader.onload = e => {
        self.volunteer.files[name] = e.target.result
      }
      reader.readAsDataURL(file)
    },

    // THUMB IF IT IS NOT AN IMAGE
    defaultPreview (e) {
      e.target.src = '/img/file.svg'
    },

    // REMOVE V-AUTOCOMPLETE OPTION
    removeOption (item) {
      let index = this.volunteer.event.indexOf(item.id)
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.volunteer.event))
        aux.splice(index, 1)
        this.volunteer.event = aux
      }
    },
    /* global isEmpty */
    /* global validateDocument */
    /* global validateEmail */
    /* global moment */
    /* global sha256 */

    // VALIDATE AND SAVE
    validate () {
      var validate = true

      isEmpty(this.volunteer.name)
        ? (this.error.volunteer.name = true) && (validate = false)
        : (this.error.volunteer.name = false)

      isEmpty(this.volunteer.surname)
        ? (this.error.volunteer.surname = true) && (validate = false)
        : (this.error.volunteer.surname = false)

      if (isEmpty(this.volunteer.id_type)) {
        this.error.volunteer.id_type = true
        validate = false
      } else {
        // DNI
        if (this.volunteer.id_type === '1') {
          if (!validateDocument(this.volunteer.id_number, 1)) {
            this.error.volunteer.id_number = true
            validate = false
          } else {
            this.error.volunteer.id_type = false
            this.error.volunteer.id_number = false
          }
        }
        // NIE
        if (this.volunteer.id_type === '2') {
          if (!validateDocument(this.volunteer.id_number, 2)) {
            this.error.volunteer.id_number = true
            validate = false
          } else {
            this.error.volunteer.id_type = false
            this.error.volunteer.id_number = false
          }
        }
      }

      isEmpty(this.volunteer.gender) ? (this.error.volunteer.gender = true) && (validate = false) : this.error.volunteer.gender = false

      isEmpty(this.volunteer.birthday)
        ? (this.error.volunteer.birthday = true) && (validate = false)
        : (this.error.volunteer.birthday = false)

      validateEmail(this.volunteer.email)
        ? (this.error.volunteer.email = true) && (validate = false)
        : (this.error.volunteer.email = false)

      isEmpty(this.volunteer.phone1)
        ? (this.error.volunteer.phone1 = true) && (validate = false)
        : (this.error.volunteer.phone1 = false)

      if (Object.keys(this.volunteer.phone1_aux).length > 0) {
        // validate if club mobile is valid
        if (this.volunteer.phone1_aux.isValid) {
        // ok save phone
          this.volunteer.phone1 = this.volunteer.phone1_aux.number.e164
          // remove  errors
          this.error.volunteer.phone1 = false
        // invalit mobile number
        } else {
          this.error.volunteer.phone1 = true
          validate = false
        }
      // empty mobile
      } else {
        this.error.volunteer.phone1 = true
        validate = false
      }

      if (this.volunteer.phone2 !== '') {
        // validate if club mobile is valid
        if (this.volunteer.phone2_aux.isValid) {
        // ok save phone
          this.volunteer.phone2 = this.volunteer.phone2_aux.number.e164
          // remove  errors
          this.error.volunteer.phone2 = false
        // invalit mobile number
        } else {
          this.error.volunteer.phone2 = true
          validate = false
        }
      }

      isEmpty(this.volunteer.country) ? (this.error.volunteer.country = true) && (validate = false) : this.error.volunteer.country = false

      isEmpty(this.volunteer.city) ? (this.error.volunteer.city = true) && (validate = false) : this.error.volunteer.city = false

      isEmpty(this.volunteer.cp) ? (this.error.volunteer.cp = true) && (validate = false) : this.error.volunteer.cp = false

      isEmpty(this.volunteer.b_carnet) ? (this.error.volunteer.b_carnet = true) && (validate = false) : this.error.volunteer.b_carnet = false
      if (this.volunteer.b_carnet !== 1) {
        this.volunteer.b_coche = ''
        this.volunteer.driveType = []
        // this.volunteer.files.drivelicense_front = "";
        // this.volunteer.files.drivelicense_back = "";
      }

      isEmpty(this.volunteer.how_meet) ? (this.error.volunteer.how_meet = true) && (validate = false) : this.error.volunteer.how_meet = false

      this.error.volunteer.event_role = false
      for (var item in this.volunteer.event) {
        if (Object.keys(this.volunteer.event[item].id).length !== 0) {
          if (Object.keys(this.volunteer.event[item].role).length === 0) {
            this.error.volunteer.event_role = true
            break
          } else this.error.volunteer.event_role = false
        }
      }

      this.volunteer.files.cv === '' ? (this.error.volunteer.cv = true) && (validate = false) : this.error.volunteer.cv = false
      this.volunteer.files.ss === '' ? (this.error.volunteer.ss = true) && (validate = false) : this.error.volunteer.ss = false
      this.volunteer.files.dni === '' ? (this.error.volunteer.dni = true) && (validate = false) : this.error.volunteer.dni = false

      //   isEmpty(this.volunteer.num_ss) ? (this.error.volunteer.num_ss = true) && (validate = false) : this.error.volunteer.num_ss = false;

      this.volunteer.studies.length === 0 ? (this.error.volunteer.studies = true) && (validate = false) : this.error.volunteer.studies = false
      if (this.volunteer.studies.length === 0) {
        this.volunteer.other_studies = ''
        this.volunteer.other_cafe = ''
      } else {
        if (this.otherStudies) {
          isEmpty(this.volunteer.other_studies) ? (this.error.volunteer.other_studies = true) && (validate = false) : this.error.volunteer.other_studies = false
        }
        // if (this.otherCafe) {
        // isEmpty(this.volunteer.other_cafe) ? (this.error.volunteer.other_cafe = true) && (validate = false) : this.error.volunteer.other_cafe = false;
        // }
      }

      // isEmpty(this.volunteer.ropec) ? (this.error.volunteer.ropec = true) && (validate = false) : this.error.volunteer.ropec = false;

      // this.volunteer.staff_level.length == 0 ? (this.error.volunteer.staff_level = true) && (validate = false) : this.error.volunteer.staff_level = false;
      if (this.volunteer.staff_level.length === 0) {
        this.volunteer.other_staff_level = ''
        this.volunteer.official_basket = ''
      } else {
        if (this.otherBasquet) {
          isEmpty(this.volunteer.official_basket) ? (this.error.volunteer.official_basket = true) && (validate = false) : this.error.volunteer.official_basket = false
        }
        if (this.otherStaffLevel) {
          isEmpty(this.volunteer.other_staff_level) ? (this.error.volunteer.other_staff_level = true) && (validate = false) : this.error.volunteer.other_staff_level = false
        }
      }

      var langEmpty = Object.values(this.volunteer.lang_level).find(obj => {
        return obj.lang === '' || obj.level === ''
      })

      if (langEmpty !== undefined) {
        this.error.volunteer.lang_level = true
        validate = false
      } else {
        this.error.volunteer.lang_level = false
      }

      isEmpty(this.volunteer.password)
        ? (this.error.volunteer.password = true) && (validate = false)
        : (this.error.volunteer.password = false)
      this.volunteer.password !== this.password2
        ? (this.error.volunteer.password2 = true) && (validate = false)
        : (this.error.volunteer.password2 = false)

      // !this.terms_and_conditions
      //   ? (this.error.terms_and_conditions = true) && (validate = false)
      //   : (this.error.terms_and_conditions = false);

      !this.privacy_policy
        ? (this.error.privacy_policy = true) && (validate = false)
        : (this.error.privacy_policy = false)

      // !this.b_work
      //   ? (this.error.b_work = true) && (validate = false)
      //   : (this.error.b_work = false);

      // validate recaptcha

      if (!this.captchaVerify) {
        this.error.recaptcha = true
        validate = false
      } else {
        this.error.recaptcha = false
      }

      if (this.volunteer.working_areas.length === 0) {
        this.error.volunteer.working_areas = true
        validate = false
      } else {
        this.error.volunteer.working_areas = false
      }

      if (this.volunteer.working_event.length === 0) {
        this.error.volunteer.working_event = true
        validate = false
      } else {
        this.error.volunteer.working_event = false
      }

      if (validate) {
        var self = this

        // GET ALL FILES ON AN ARRAY
        var files = []
        Object.entries(this.volunteer.files).forEach(([key]) => {
          files[key] = self.$refs[key].files[0]
        })

        this.$overlay.loading()

        this.lang = this.$route.params.lang

        if (!['ca', 'es'].includes(this.lang)) {
          this.lang = 'ca'
        }

        this.$store
          .dispatch('persons/addVolunteer', {
            lang: this.lang,
            name: self.volunteer.name,
            surname: self.volunteer.surname,
            document_type: self.volunteer.id_type,
            dni: self.volunteer.id_number,
            birthday: self.volunteer.birthday,
            gender: self.volunteer.gender,
            email: self.volunteer.email,
            phone1: self.volunteer.phone1,
            phone2: self.volunteer.phone2,
            country: self.volunteer.country,
            cp: self.volunteer.cp,
            city: self.volunteer.city,
            b_carnet: self.volunteer.b_carnet,
            instagram: self.volunteer.instagram,
            how_meet: self.volunteer.how_meet,
            event: JSON.stringify(self.volunteer.event),
            rrss: JSON.stringify(self.volunteer.rrss),
            referee_experience: self.volunteer.referee_experience,
            referee3po: self.volunteer.referee3po,
            studies: self.volunteer.studies,
            other_studies: self.volunteer.other_studies,
            working_areas: self.volunteer.working_areas,
            working_event: self.volunteer.working_event,
            other_cafe: self.volunteer.other_cafe,
            ropec: self.volunteer.ropec,
            staff_level: self.volunteer.staff_level,
            other_staff_level: self.volunteer.other_staff_level,
            official_basket: self.volunteer.official_basket,
            idiomas: JSON.stringify(self.volunteer.lang_level),
            events_done: JSON.stringify(self.volunteer.events_done),
            password: sha256(self.volunteer.password),
            files: files,
            b_work: self.b_work,
            num_ss: self.volunteer.num_ss
          })
          .then(function (response) {
            self.$overlay.hide()

            if (response) {
              self.$popup.alert(
                {
                  message: i18n.t('params.new_volunteer_success'),
                  btnSuccess: i18n.t('accept')
                },
                function () {
                  self.$router.push('/login')
                }
              )
            } else {
              self.$popup.alert({
                message: i18n.t('params.new_volunteer_error'),
                btnSuccess: i18n.t('accept')
              })
            }
          })
      } else {
        let self = this
        this.$popup.alert({
          message: i18n.t('errors.form'),
          btnSuccess: i18n.t('accept')
        }, function () {
          var el = self.$el.getElementsByClassName('error')[0]
          el.scrollIntoView({ block: 'center', behavior: 'smooth' })
        })
      }
    },

    formatBirthday () {
      this.volunteer.parsedBirthday = moment(this.volunteer.birthday).format('DD/MM/YYYY')
    },

    formatRopec () {
      this.volunteer.parsedRopec = moment(this.volunteer.ropec).format('DD/MM/YYYY')
    },

    selectAll () {
      this.$nextTick(() => {
        if (this.allEvents) {
          this.volunteer.event = { id: '', role: '' }
        } else {
          for (var item in this.activeEvents) {
            this.volunteer.event = [{ id: '', role: '' }]
            this.volunteer.event[item].id = this.activeEvents[item].id
          }
        }
      })
    }

  },

  computed: {
    activeEvents () {
      var oEvents = Object.assign({}, this.events)
      for (var e in oEvents) {
        oEvents[e].name = oEvents[e].name + ' ' + oEvents[e].edition
      }
      return Object.values(oEvents).filter(item => item.status === 1 && item.name.toLowerCase().includes('micfootball'))
    },

    roleParent () {
      return Object.values(this.role_volunteer).filter(item => item.parent_id == null && item.status === 1)
    },

    roleChildren () {
      return Object.values(this.role_volunteer).filter(item => item.parent_id != null && item.status === 1)
    },

    roleRefereeFiltered () {
      // ROLES WITHOUT REFEREE
      var result = { ...this.role_volunteer }

      var referee = Object.values(this.role_volunteer).find(obj => {
        return obj.name === 'referee_category'
      })

      delete result[referee.id]

      return Object.values(result).filter(item => item.parent_id == null && item.status === 1)
    },

    basketReferee () {
      var basket = Object.values(this.events).find(obj => {
        return obj.name === 'MICBasketball'
      })

      var positions = []
      if (basket) {
        for (var item in this.volunteer.event) {
          console.log(this.volunteer.event[item], basket)
          if (this.volunteer.event[item].id.indexOf(basket.id) > -1) {
            positions.push(parseInt(item))
          }
        };
      }

      return positions
    },

    years () {
      var currentYear = parseInt(moment().format('YYYY'))
      var year = 2001
      var years = []
      while (year < currentYear) {
        years.push(year.toString())
        year++
      }

      return years.sort().reverse()
    }

  },

  watch: {
    // HIDE OVERLAY WHEN FILE IS UPDATED
    'volunteer.files': {
      deep: true,

      handler () {
        this.$overlay.hide()
      }
    },

    'volunteer.parsedBirthday': function () {
      if (moment(this.volunteer.parsedBirthday, 'DD/MM/YYYY').isValid()) {
        this.volunteer.birthday = moment(this.volunteer.parsedBirthday, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    },

    'volunteer.parsedRopec': function () {
      if (moment(this.volunteer.parsedRopec, 'DD/MM/YYYY').isValid()) {
        this.volunteer.ropec = moment(this.volunteer.parsedRopec, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    }
  }
}
</script>

<style lang="scss">
body {
  overflow: auto !important;
}

 .vti__input {
    border: unset !important;
 }

.action {
  position: fixed;
  width: 10%;
  float: left;
  text-align: center;

  .back {
    text-align: center;
    padding: 20px 10px;
    cursor: pointer;
    display: inline-block;

    .text {
      text-align: center;
      padding: 20px 10px;
      cursor: pointer;
      font-size: 19px;
      color: white;
      font-weight: bold;
      display: inline-block;
    }

    img {
      position: relative;
      top: 3px;
      height: 20px;
      width: 20px;
      display: inline-block;
    }
  }
}

@media (max-width: 760px) {
  .back {
    display: none !important;
    img {
      height: 30px !important;
      width: 30px !important;
    }
    .text {
      display: none !important;
    }
  }

  .mobile-box {
    border-bottom: 1px solid #cacaca;
    margin-bottom: 10px !important;

    &:last-of-type {
      border-bottom: none !important;
    }
  }

  .flex  {
    display: inline-table !important;
  }

  #newvolunteer #form {
    width: 100% !important;
    padding: 10px 15px !important;
    overflow: hidden;
  }

  h2 {
      width: 100% !important;
      font-size: 27px !important;
      margin-left: 0px !important;
      margin-right: 0px !important;
  }

  h3 {
    font-size: 19px !important;
    line-height: 1.6 !important;
  }

  .v-input {
    width: 100% !important;
  }

  .icon {
    width: 100% !important;
    text-align: center !important;
    margin: 0 auto !important;
    padding-top: 0px !important;
      i {
        display: inline;
        padding: 0px 10px;
      }
  }

  .v-list__tile__title {
    text-overflow: initial !important;
    height: auto !important;
    overflow: initial !important;
    position: static !important;
    white-space: normal !important;
    max-width: initial !important;
    max-height: none !important;
    padding: 12px 0 !important;
  }

  .v-list__tile {
    height: fit-content !important;
    min-height: 48px !important;
  }

  .v-chip {
    white-space: normal !important;
    padding: 7px 5px !important;

    .v-chip__content {
      height: fit-content !important;
      white-space: normal !important;
    }
  }

  .header {
    text-align: center;
    .logo {
      text-align: center;
      float: none !important;
      margin-top: 10px !important;
    }
  }
}

#newvolunteer {
  background: $dark-color;
  margin: 0;
  padding: 5px;
  height: 100%;

  .header {
    width: 100%;
    overflow: hidden;

    h2 {
      float: left;
    }

    .logo {
      float: right;
      margin-top: 20px;

      p {
        display: inline;
        vertical-align: super !important;
      }

      img {
        cursor: default !important;
      }
    }
  }

  hr {
    background-color: #ccc;
    margin: 30px auto;
    width: 95%;
    background-color: transparent;
  }

  h2,
  h3,
  h4,
  h6 {
    font-family: AvantGarde-Bold;
    color: black !important;
    text-transform: uppercase;
    display: block;
  }

  h3 {
    padding-left: 10px !important;
    font-size: 24px;
    background: black;
    color: #fff !important;
    padding: 4px;
    width: 100%;
  }

  h6 {
    font-size: 18px;
    background: #eee;
    color: #999 !important;
    padding: 8px;
  }

  .alert {
    background-color: #e5faff;
    padding: 15px;
    width: 98%;
    margin: 20px auto;
    font-size: 16px;
  }

  .container.fluid.grid-list-md {
    padding: 0;
  }

  #top-description {
    text-align: center;

    h3 {
      font-family: AvantGarde-Bold;
      text-align: center;
    }

    .description {
      margin: 0 auto;
      display: inline-block;
      p {
        text-align: justify;
        text-justify: inter-word;
        font-family: AvantGarde-Bold;
      }
    }
  }

  #form {
    width: 80%;
    margin: 0 auto;
    padding: 10px 20px;
    background-color: #fff;
    border-radius: 4px;
    min-height: calc(100vh - 10px);

    h2 {
      text-align: center;
      text-transform: uppercase;
      font-style: italic;
      font-family: AvantGarde-Bold;
    }

    .v-menu__content {
        * {
            text-decoration: none !important;
        }
    }

    a {
      text-decoration: underline;
      cursor: pointer;
      font-weight: bold;
      font-family: AvantGarde-Bold;
    }

    .info {
      p,
      h4 {
        font-family: Roboto-Light;
        color: #555;
        font-size: 17px;
      }
    }

    .box {
      width: 100%;
      margin: 0 auto;
      height: auto;
      font-family: AvantGarde-Bold;
      margin-bottom: 20px;

      // background-color: var(--event_color);

      .message.error {
        color: $warning-color;
        // font-family: AvantGarde-Bold;
      }

      label {
        display: block;
        font-family: AvantGarde-Bold;
        font-size: 14px;
        margin-bottom: 3px;
        // padding: 0;
        // margin-bottom: 5px;
        display: block;
        color: black;
        font-weight: bold;
      }

      .item {
        width: 90%;
        margin: 0 auto;

        .v-input {
          margin-top: 0;
          padding-top: 0;
        }

        input,
        textarea,
        select,
        .v-autocomplete .v-input__slot {
          width: 100%;
          padding: 5px 6px;
          margin-bottom: 0;
          border: 1px solid $main-color;
          outline: none;
          font-size: 11pt;
          border-radius: 3px;
          color: $dark-color;
          font-family: Roboto-Light;
          font-weight: lighter;
          resize: vert;
          min-height: 40px;
          height: fit-content;

           &::placeholder {
              color: $dark-color;
              // font-family: Roboto-Light;
              // font-weight: lighter;
              opacity: 0.5;
          }

          &.shadow:focus {
            border-color: #66afe9;
            outline: 0;
            border-left: 6px solid #66afe9;
            // -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
            // box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
          }
        }

        .vue-tel-input {
          border: 1px solid $main-color;

          .vti__dropdown {
            border-right: 1px solid #ccc;
          }

          input {
            border: unset;
          }
        }

        .v-input__append-inner {
          margin-top: 7px !important;
        }

        .v-input__control {
          margin: 0 auto;
        }

        .v-select__slot {
          padding: 0;
          width: 100%;
          margin-bottom: 0;
          border: 1px solid #172654;
          outline: none;
          font-size: 11pt;
          border-radius: 3px;
          color: #222;
          font-family: Roboto-Light;
          font-weight: lighter;
          min-height: 35px;
          height: -webkit-fit-content;
          height: -moz-fit-content;
          height: fit-content;

          .v-select__selections {
            input {
              border: none !important;
              margin: 0;
            }
          }
        }

        .date-picker.error {
          input {
            border: 1px solid red;
          }
        }

        .error {

                    input {
                        border: 1px solid red;
                    }
                }

        .v-autocomplete {
          margin-top: 0;
          padding-top: 0;
          font-family: AvantGarde-Bold;
          .v-input__control {
            font-family: AvantGarde-Bold;
            .v-input__slot {
              margin: 0;
              padding: 0;

              &:after,
              &:before {
                content: "";
                border: none !important;
                font-family: AvantGarde-Bold;
              }
            }
            .v-select__slot {
              border: none;
              font-family: AvantGarde-Bold;
              // padding: 5px 12px;
              padding: 0;
              input {
                border: none;
                margin: 0;
              }
            }
          }
        }

        .error {
          border-color: red !important;
          // font-family: AvantGarde-Bold;
          &::placeholder {
            color: $alert-color !important;
            opacity: 1;
            // font-family: AvantGarde-Bold;
          }
          .v-input__slot {
            border-color: $alert-color;
            // font-family: AvantGarde-Bold;
          }

          .v-select__slot {
            border-color: red !important;
          }
        }

        .upper {
          text-transform: uppercase;
          // font-family: AvantGarde-Bold;
          // &::placeholder {
          //   text-transform: none;
          //   font-family: AvantGarde-Bold;
          // }
        }

        span {
          color: black;
          font-size: 16px;
          // font-weight: bold;
          // font-family: AvantGarde-Bold;
        }
      }

      .v-list__tile__title {
        text-overflow: initial !important;
        height: auto !important;
        overflow: initial !important;
        position: static !important;
        white-space: normal !important;
        max-width: initial !important;
        max-height: none !important;
        padding: 12px 0 !important;
      }

      .v-list__tile {
        height: fit-content !important;
        min-height: 48px !important;
      }

      .v-chip {
        white-space: normal !important;
        padding: 7px 5px !important;

        .v-chip__content {
          height: fit-content !important;
          white-space: normal !important;
        }
      }

      img {
        border-style: none;
        max-height: 35px;
        cursor: pointer;
        display: inline;
      }

      .filename {
        display: inline;
        position: relative;
        bottom: 10px;
        padding: 12px;
      }

      .categories {
        vertical-align: top;

        .v-input--is-label-active {
          // border-left: 5px solid #ccc;

          // & {
          //   border-left: 5px solid #ccc;
          // }

          span {
            font-weight: bold;
            font-family: AvantGarde-Bold;
          }
        }

        .v-input--is-label-active + .teams {
          font-family: AvantGarde-Bold;
        }

        .v-input__slot,
        .v-label {
          margin: 0;
        }

        input {
          display: inline-block;
          width: 100%;
        }
        .text {
          display: inline-block;
          width: 100%;
          margin: 0;
        }

        .teams {
          display: inline-block;
          vertical-align: top;
          margin-bottom: 25px;

          .teams_number_description {
            width: auto;
            display: inline-block;
            margin-right: 10px;
          }
          .teams_number {
            width: 40px;
            display: inline-block;
            text-align: center;
          }
        }
      }

      .middle-box {
        width: fit-content;
        margin: 0 auto;
        text-align: center;

        .legal {
          //text-align: center;
        }

        .save {
          margin-bottom: 20px;
        }
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      select {
        background-image: url("/img/sort-down.svg");
        background-size: 10px;
        background-position: right 10px center;
        background-repeat: no-repeat;
        font-family: AvantGarde-Bold;
      }

      select option {
        font-size: 14pt;
      }

      #send {
        max-width: 300px;
        width: 100%;
        padding: 15px;
        outline: none;
        border: none;
        cursor: pointer;
        font-size: 12pt;
        font-family: AvantGarde-Bold;
        margin-top: 25px;
        border-radius: 3px;
        border: 1px solid $secondary-color;
        text-transform: uppercase;
        transition: all 0.5s;
        background: black;
        color: $secondary-color;

        &:hover {
          background: #222 !important;
        }
      }
    }

    .obligatory {
      color: $alert-color !important;
      font-weight: bold;
      // font-family: AvantGarde-Bold;
    }

    .v-input__slot {
      margin: 0;
    }

    /*
      .checkbox, .description {
        display: inline-block;
        padding: 0;
        margin: 0;
      }

      .checkbox {
        width: auto;
        // width: 25px;
        border: 1px solid red;
      }

      .description {
        vertical-align: middle;
        margin-left: 10px;
      }
      */
  }

  .terms_and_conditions {
    margin: 0;
    display: inline-block;
  }

  .information {
    border: 1px solid $secondary-color;
    margin-left: 10px;
    padding: 10px;
  }

  .form-subtitle {
    margin-top: 36px;

    &:first-of-type {
      margin-top: 12px;
    }
  }

  @media (max-width: 720px) {
    #form {
      .box {
        .item {
          width: calc(100% - 20px);
        }
      }
    }
  }
}

#popup1 {
  height: auto;
  background-color: white;
  padding: 20px;

  .header {
    margin-bottom: 50px;
    // border-bottom: 1px solid $secondary-color;

    img {
      width: 25px;
      height: 25px;
      float: right;
      margin: 10px;
      cursor: pointer;
    }
  }

  .main {
    .title {
      margin: 10px 0;
    }

    p {
      margin: 0;
      margin-bottom: 20px;
      // font-family: AvantGarde-Bold;
    }
  }

  a {
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
    font-family: AvantGarde-Bold;
  }
}

/*@include media(">phone1", "<tablet") {

    .categories {
      vertical-align: top;
       .text, span {
        display: block;
        width: 100%;
        text-align: center;
      }
    }
    .teams_number {
        display: block !important;
        margin: 0 auto !important;
        text-align: center !important;
        width: 50% !important;
    }

    .teams {
      display: block !important;
      text-align: center;
      margin: 0 auto;
    }

    .item {
      margin: 0 !important;
    }
  }*/
</style>
